import { render, staticRenderFns } from "./SelectCertificate.vue?vue&type=template&id=06ea53a3"
import script from "./SelectCertificate.vue?vue&type=script&lang=js"
export * from "./SelectCertificate.vue?vue&type=script&lang=js"
import style0 from "./SelectCertificate.vue?vue&type=style&index=0&id=06ea53a3&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports